import { useMutation } from '@apollo/client';
import * as AuthQuery from 'graphql/auth.graphql';
import * as PaymentQuery from 'graphql/payment.graphql';
import useUserSession from './useUserSession';
import { SessionPreferences } from 'api/data/user/types';

export type InputSessionPreferences = { [key: string]: string | boolean | null };

const useUpdateSessionPreferences = (spaceSlug: string) => {
  const { data: userSession } = useUserSession();
  const sessionQuery = { query: AuthQuery.Session };
  const terminalQuery = {
    query: PaymentQuery.PaymentTerminals,
    variables: { currentSpace: spaceSlug },
  };

  const [updateSessionPreferences] = useMutation<{
    updateSessionPreferences: {
      sessionPreferences: SessionPreferences;
    };
  }>(AuthQuery.UpdateSessionPreferences, {
    refetchQueries: [terminalQuery, sessionQuery],
  });

  const session = userSession?.session;

  const updatePreferences = async (input: InputSessionPreferences) => {
    await updateSessionPreferences({
      variables: { input },
      update: cache => {
        cache.writeQuery({
          query: AuthQuery.Session,
          data: {
            session: {
              ...session,
              sessionPreferences: {
                ...session?.sessionPreferences,
                ...input,
              },
            },
          },
        });
      },
    });
  };

  return updatePreferences;
};

export default useUpdateSessionPreferences;
